import { constructionSafety, logisticsAsset, manufacturingAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/medicalWaste/video/rtlsVideo.mp4';

export default {
  desc: 'BLE, hay Bluetooth Low Energy (Bluetooth Năng lượng Thấp), là một công nghệ truyền thông không dây được sử dụng chủ yếu cho các thiết bị tiêu thụ năng lượng thấp. Với đặc điểm tiêu thụ ít điện năng và dễ triển khai, BLE được ứng dụng rộng rãi trong các lĩnh vực như xây dựng, sản xuất và y tế. Trong bài viết này, chúng ta sẽ tìm hiểu chi tiết về khái niệm cơ bản, nguyên lý hoạt động, các đặc điểm nổi bật và các ứng dụng thực tiễn của BLE.',
  keywords: 'Bluetooth, BLE, Beacon, RTLS, ORBRO',
  ogSite: 'BLE Là gì? | Bluetooth Low Energy',
  title: 'BLE Là gì? | Bluetooth Low Energy',
  ogUrl: 'https://orbro.io/vi/blog/ble',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDnfNjLOQqRH35cwkWdJ-bHoz620gNvKlc65H16bDwbDmM9mn2WV9CZBz5ngF-qPG8Kaio7OwcThigmqtAyLII5-_7o_wuEr9IGXgBBhy_HG2TtVg8JvI3jjx47Vjw5bkjNMP9pqYdZG-uQE7MSvCn-fUZW5RKVlHT6Wej9ZUjr8AuM0noE2LJXIBs8o7Ik2bNeGQcps-3AfWrgOGhlIFNJuCK2uSB1AW_cjwmHTkEIusWJalOUeSVOcaarM8cTR1xUNWmao0lb1KbxQ8qqbL4_XhFZkkUct1UG8RrIN6Psi-AsTpgkFOrBdDPlqH541BEN9bwdOETx3Kgc9iRes1JUSRoP7nrOyakxoo3aqXTFdAoosGnVLKOiER0DPiU3G07ZA9bJlehSeDDCzu8kynXgnTFz91gKfMi3avcdxHqpzaiBhQCXLBUaUM95BEkE-EXHcK8Nl2WmqiTNP7CThyNvqwZdyy1JVK3ZAc5waSTB186EjteUi4k9pd65QfukNba5px9D4ul0TIzbpY_aBS2bxSfdqlASAVpqQacahwDH0yFO0S1gPaNEMW4Rcqk4iQBol7VLpCY1Snlty4mEaUfgoKOxdkkZU3nUI7YT5EXM3uWYUNTI7a2y9qeT4hrtloASb9mN6DcMg_aqnP7emz1CZ-imi3vFJic3ohSrWlQulA-3p__vjLjaVuslbfw63OjFvQAtmnYu1VRZInPMAtDL_vflRts6E5KekPnuL4Ca5Kze4Wh9CVzuPlcdqh4jXIkUI4GEE6n9fX8ZU3eWJ3vJXWl5AsFXSA5fbMZ399h7V9B5DzuThH9vBR99mQqMnDcu-wMSq8GtgfrQvtysw0KoPKwz2uo8D1Wg5qhsJ9KCDj_gm3BY67-wftHaGOtlwve9hBoHyAlPwsV0BA4t6_tpuqzg3jfkv8hlWyWZ7x9KUguu0Im_zMOGYfPw_YdhWZoe_erVB6bGz7UHbyN2Vo-aMOK4eAjPDtOgP0qR90Sg-KjmiPwCEGL1SFTjzDht-pBQVVLCOMRzOuRArCvUZai0a4G2-JBnIxVPxNfCsLrLu33X6-UgxzpkrQfBr0YcAINxqDA_IfOOJc3C9PKFPyhTgp7cP_KVk2QsY25pHgMDTc49Ui4nwk2FxSdvlshqEZHbPKbtQHQ_JK-y3veLdrgV9ADCimrqBeHANlcWKuovdxhGvrr2mlRG-t2pD_62qO-Gh0t93pn9qocK1oVmPweHfGPMC2E1Z_GtmeOr33-mwXkKK-R7LUT7aLOO359xDj0C__aXlIFScOt-8RVul4IJ8HQoENLTkwNTs-jt-Z_LMbO73LvC5YlngDpmg1n9_NLCcomYIxw6PBKksDaqWJM732sqJiEsvmm9NYyVnBneRLbCAIKbq6xsH1y98rbeCc8tlWYSBfUNFx-CvWG-L_8IrgL0bhnMKFzN4bHqJCVezRfIHgDdfdOwOSN3xxFZmg4KSWjdPA3VtyO57X_zgNjlVtEE6PDawKLNXUiaAd6nyZtpP-FLbph9jZ7-Ws8g_A_gHtSv2NQOq3CQ73x9_YgopHxq4rJ3W=w2189-h1213',
  ogType: 'website',
  date: '2024-01-04',
  tag1: '#BLE',
  tag2: '#BluetoothLowEnergy',
  tag3: '#Bluetooth',
  tag4: '#Beacon',
  text: [
    {
      head: 'BLE là gì?',
      subHead: '',
      desc: 'BLE, hay Bluetooth Low Energy (Bluetooth Năng lượng Thấp), là một công nghệ truyền thông không dây được sử dụng chủ yếu cho các thiết bị tiêu thụ năng lượng thấp. Với đặc điểm tiêu thụ ít điện năng và dễ triển khai, BLE được ứng dụng rộng rãi trong các lĩnh vực như xây dựng, sản xuất và y tế. Trong bài viết này, chúng ta sẽ tìm hiểu chi tiết về khái niệm cơ bản, nguyên lý hoạt động, các đặc điểm nổi bật và các ứng dụng thực tiễn của BLE.',
      dot: '',
    },
    {
      head: 'Khái niệm cơ bản về BLE',
      subHead: '',
      desc: 'BLE (Bluetooth Low Energy) được thiết kế dành riêng cho việc kết nối giữa các thiết bị tiêu thụ năng lượng thấp như điện thoại thông minh, thiết bị đeo, cảm biến và thiết bị y tế. Tương tự như Bluetooth truyền thống, BLE sử dụng băng tần 2.4GHz nhưng được tối ưu hóa để giảm thiểu tiêu thụ năng lượng, giúp kéo dài tuổi thọ pin trong thời gian dài.',
      dot: '',
    },
    {
      head: 'Nguyên lý hoạt động của BLE',
      subHead: '',
      desc: 'BLE hoạt động dựa trên hai chế độ chính: Advertising (Quảng bá) và Connection (Kết nối). Ở chế độ Advertising, thiết bị phát tín hiệu để thông báo sự hiện diện của mình tới các thiết bị xung quanh. Trong chế độ Connection, các thiết bị thực hiện trao đổi dữ liệu thực tế. Nhờ cơ chế này, BLE duy trì hiệu quả truyền thông ngay cả trong trạng thái tiêu thụ năng lượng thấp.',
      dot: '',
    },
    {
      head: 'Đặc điểm nổi bật của BLE',
      subHead: 'Tiêu thụ năng lượng thấp',
      desc: 'BLE được thiết kế phù hợp với các thiết bị chạy bằng pin. Ở chế độ quảng bá, BLE hoạt động với mức năng lượng rất thấp, và ngay cả khi kết nối, nó vẫn duy trì mức tiêu thụ tối ưu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ứng dụng đa dạng',
      desc: 'BLE được sử dụng trong nhiều lĩnh vực khác nhau, từ nhà thông minh, y tế thông minh, thành phố thông minh đến các dịch vụ định vị, mạng cảm biến và theo dõi vị trí trong nhà.',
      dot: '',
    },
    {
      head: 'Ứng dụng của BLE: Công nghệ RTLS',
      subHead: 'Hệ thống theo dõi vị trí thời gian thực (RTLS)',
      desc: 'BLE đóng vai trò quan trọng trong công nghệ RTLS, một hệ thống cho phép theo dõi vị trí của đối tượng hoặc vật thể theo thời gian thực, được ứng dụng rộng rãi trong nhiều ngành công nghiệp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý logistics và kho bãi',
      desc: 'Trong lĩnh vực logistics và kho bãi, các thẻ BLE được sử dụng để theo dõi vị trí của hàng hóa hoặc tài sản theo thời gian thực. Điều này giúp tối ưu hóa quản lý kho, cải thiện quy trình cung ứng và tối ưu hóa lộ trình di chuyển trong kho, từ đó nâng cao hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Dịch vụ định vị trong nhà (IPS)',
      desc: 'BLE đóng vai trò quan trọng trong các dịch vụ định vị trong nhà. Tại các trung tâm thương mại, sân bay hay bảo tàng, ứng dụng trên điện thoại thông minh có thể cung cấp bản đồ trong nhà, thông tin khuyến mãi hoặc thông tin về các triển lãm nhờ công nghệ BLE.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý quy trình sản xuất',
      desc: 'Trong ngành sản xuất, BLE hỗ trợ theo dõi vị trí của thiết bị, linh kiện hoặc sản phẩm trong dây chuyền sản xuất theo thời gian thực. Điều này giúp tăng hiệu quả sản xuất và giảm thiểu thời gian xử lý sự cố.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hệ thống y tế',
      desc: 'Trong các bệnh viện hoặc cơ sở y tế, BLE được sử dụng để theo dõi vị trí của bệnh nhân và giám sát trạng thái của các thiết bị y tế. Công nghệ này hỗ trợ phản ứng nhanh trong các tình huống khẩn cấp và cải thiện việc theo dõi bệnh nhân.',
      dot: '',
    },
    {
      head: 'Triển vọng',
      subHead: '',
      desc: 'BLE đang không ngừng phát triển và được dự đoán sẽ mở rộng ứng dụng trong nhiều lĩnh vực công nghiệp và đời sống. Các cải tiến về bảo mật, tốc độ truyền dữ liệu cao hơn và phạm vi kết nối rộng hơn sẽ là những hướng phát triển chính của BLE trong tương lai. Những tiến bộ này hứa hẹn tạo ra một môi trường truyền thông không dây hiệu quả và tiện lợi hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
